import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { VisitorLeaveSummaryComponent } from './component/visitor-leave-summary.component';



@NgModule({
  declarations: [
    VisitorLeaveSummaryComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    CommonTranslationModule,
    CommonUIModule
  ]
})
export class VisitorLeaveSummaryModule { }
